import IpoBanner from './IpoBanner';    
import IpoSection from './IpoSection';    

function Ipo() {
  return (
    <div>
    <IpoBanner/>
    <IpoSection/>
    </div>
  );
}

export default Ipo;